import { RouteConfig } from 'vue-router';
import applicationsRoutes from './applicationsRoutes';
import profileRoutes from './profileRoutes';
import providersDashboardRoutes from './providersDashboard';
import availabilityRoutes from './availabilityRoutes';
import bookingsRoutes from './bookingsRoutes';

const providerRoutes = [
  ...applicationsRoutes,
  ...profileRoutes,
  ...providersDashboardRoutes,
  ...availabilityRoutes,
  ...bookingsRoutes,
] as RouteConfig[];

export default providerRoutes;
